import { GuestExperienceDashboardPage } from '../../pages/GuestExperienceDashboardPage';

/**
 * GX Feed panel for the Mobile Organizer Toolkit.
 * Renders the GuestExperienceDashboardPage inline with the Legacy Ball event ID.
 */
export function GxFeedPanel() {
  // Legacy Ball event ID
  const LEGACY_BALL_EVENT_ID = 'e1000000-0000-0000-0000-000000000003';

  return (
    <div style={{ padding: '0', overflow: 'auto', height: '100%' }}>
      <GuestExperienceDashboardPage eventIdOverride={LEGACY_BALL_EVENT_ID} />
    </div>
  );
}
